import * as React from "react";
import { CircleCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const benefits = [{
  title: "Exclusive Member Pricing",
  description: "Enjoy significant discounts on all IV drips, vitamin injections, and premium wellness services."
}, {
  title: "Complimentary Monthly Services",
  description: "Receive one free core service per month, such as an infrared sauna session or B12 injection."
}, {
  title: "Priority Booking",
  description: "Get first access to preferred appointment times and skip the waitlist for high-demand treatments."
}, {
  title: "Advanced Lab Testing Discounts",
  description: "Access comprehensive biomarker and wellness panels at special member-only rates."
}, {
  title: "Personalized Wellness Plan",
  description: "Quarterly consultations with our medical staff to optimize and adjust your health protocol."
}, {
  title: "Guest Privileges",
  description: "Bring a friend once a quarter to experience a complimentary detox session."
}];
export default function MemberBenefits() {
  return <section id="memberbenefits" className="bg-card py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12 lg:mb-16">
          <div className="max-w-2xl">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl text-foreground mb-4 tracking-tight">
              Member Benefits
            </h2>
            <p className="font-sans text-lg text-muted-foreground leading-relaxed">
              Elevate your self-care routine with our exclusive membership tiers. 
              Designed for those committed to optimal health, longevity, and ethereal precision.
            </p>
          </div>
          <div className="shrink-0">
            <Button asChild size="lg" className="font-sans rounded-full px-8 bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90">
              <Link to="/MembershipsPage">
                Join Membership
              </Link>
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
          {benefits.map((benefit, i) => <Card key={i} data-index={i} className="bg-card border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300">
              <CardContent className="p-6 md:p-8 flex items-start gap-4 md:gap-6">
                <div className="shrink-0 mt-1">
                  <CircleCheck className="w-6 h-6 md:w-8 md:h-8 text-[var(--color-green-accent)]" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="font-default font-bold text-xl md:text-2xl text-foreground mb-2">
                    {benefit.title}
                  </h3>
                  <p className="font-sans text-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}